import moment from "moment";
import { checkoutStyle, modalStyles, orderHistory } from "../../../theme/theme";
import CloseButton from "../../closeButton/CloseButton";

import Button from "../../button/Button";

import ProductItems from "./ProductItem";
import Input from "../../input/Input";

const EditOrderModal = (props) => {
  const {
    toggle,
    modalVisible,
    title,
    currentOrder,
    companyChange,
    handleHingeChange,
    handleAmountChange,
    removeItemFromOrderListHandler,
    updateOrder,
    openAddProductModalHandler,
    addShipmentCostHandler,
    addCustomCutCostHandler,
    customCutCost,
    shipmentCost,
    setShipmentCost,
    setCustomCutCost,
  } = props;

  return (
    <div
      className={
        modalVisible ? modalStyles["overlayShow"] : modalStyles["overlayHide"]
      }
    >
      <div
        className={`${"min-h-modal-mobile tablet:min-h-modal-h "} [width:900px]   mx-5 z-50 relative  my-auto  tablet:mx-auto min-w-57rem  flex flex-col bg-white rounded-32`}
      >
        <div className=" [height:99px] rounded-t-32  px-14 bg-primary flex flex-col items-start justify-center relative ">
          <h2 className="font-bold text-lg desktop:text-2xl text-white">
            {title}
          </h2>
          <CloseButton
            className=" top:7 right-7 absolute"
            currentColor="white"
            onClick={toggle}
          />
        </div>
        <div className="pt-14 pb-12 px-5 tablet:px-10 flex flex-col ">
          <div className={"flex flex-col gap-6 mb-14"}>
            <div>
              <h2 className={orderHistory["titleGray"]}>Date</h2>
              <h2 className={orderHistory["titleBlack"]}>
                {moment(currentOrder?.createdAt?.toDate()).format(
                  "MMMM-DD-YYYY"
                )}
              </h2>
            </div>
            <div>
              <h2 className={orderHistory["titleGray"]}>User</h2>
              <h2 className={orderHistory["titleBlack"] + " break-words"}>
                {currentOrder.createdBy}
              </h2>
            </div>
            <div>
              <Input
                classOverride
                className={checkoutStyle["textInput"]}
                name="company"
                type="text"
                defaultValue={currentOrder?.company}
                value={currentOrder?.company}
                placeholder="Company Name"
                required={true}
                onChange={companyChange}
              />
            </div>
            <div>
              <h2 className={orderHistory["titleGray"]}>Price</h2>
              <h2 className={orderHistory["titleBlack"]}>
                $ {currentOrder.totalPrice.toFixed(2)}
              </h2>
            </div>
            <div className="flex-grow mx-4 border-t border-#D8D8D8 mt-4 opacity-1"></div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <h2>Order list</h2>
              <button
                className="[width:200px] [height:48px] [border-radius:1rem] border border-black  "
                onClick={openAddProductModalHandler}
              >
                <span className="text-txtBlack">Add product</span>
              </button>
            </div>

            <ProductItems
              order={currentOrder}
              handleHingeChange={handleHingeChange}
              handleAmountChange={handleAmountChange}
              removeItemFromOrderListHandler={removeItemFromOrderListHandler}
            />
          </div>
          <div className="flex flex-col  gap-4  mb-6">
            <div className="flex flex-row justify-end gap-2">
              <Input
                classOverride
                className={checkoutStyle["numberInput"]}
                name="CustomCutCost"
                type="number"
                value={customCutCost === 0 ? undefined : customCutCost}
                placeholder="$0"
                onChange={(e) => setCustomCutCost(+e.target.value)}
              />
              <Button
                title="Add cut cost"
                className="mt-10 [width:200px] [min-height:48px] [margin:0px] [height:48px]"
                onClick={addCustomCutCostHandler}
              />
            </div>
            <div className="flex flex-row  justify-end gap-2">
              <Input
                classOverride
                className={checkoutStyle["numberInput"]}
                name="shipmentCost"
                type="number"
                value={shipmentCost === 0 ? undefined : shipmentCost}
                placeholder="$0"
                onChange={(e) => setShipmentCost(+e.target.value)}
              />
              <Button
                title="Add shipment cost"
                className="mt-10 [width:200px] [min-height:48px] [margin:0px] [height:48px]"
                onClick={addShipmentCostHandler}
              />
            </div>
          </div>
          <div className="flex w-full justify-between">
            <h2 className="text-txtGray text-lg">Subtotal</h2>
            <div className="font-bold text-txtBlack text-lg">
              $ {currentOrder.subtotal?.toFixed(2)}
            </div>
          </div>
          {currentOrder.isTaxable &&
            typeof currentOrder.salesTax === "number" && (
              <div className="flex w-full justify-between">
                <h2 className="text-txtGray text-lg">Sales Tax</h2>
                <div className="font-bold text-txtBlack text-lg">
                  $ {currentOrder.salesTax?.toFixed(2)}
                </div>
              </div>
            )}
          {currentOrder.isAssemble && (
            <div className="flex w-full justify-between">
              <h2 className="text-txtGray text-lg">Assemble Fee</h2>
              <div className="font-bold text-txtBlack text-lg">
                $ {currentOrder.assembleFee?.toFixed(2)}
              </div>
            </div>
          )}

          {currentOrder.isTouchUpKit && (
            <div className="flex w-full justify-between">
              <h2 className="text-txtGray text-lg">TouchUpKit</h2>
              <div className="font-bold text-txtBlack text-lg">
                $ {currentOrder.touchUpKit?.toFixed(2)}
              </div>
            </div>
          )}
          {currentOrder?.shipmentCost && (
            <div className="flex w-full justify-between">
              <h2 className="text-txtGray text-lg">Shipment Cost</h2>
              <div className="font-bold text-txtBlack text-lg">
                $ {currentOrder?.shipmentCost?.toFixed(2)}
              </div>
            </div>
          )}
          {currentOrder?.customCutCost && (
            <div className="flex w-full justify-between">
              <h2 className="text-txtGray text-lg">Custom Cut Cost</h2>
              <div className="font-bold text-txtBlack text-lg">
                $ {currentOrder?.customCutCost?.toFixed(2)}
              </div>
            </div>
          )}

          <div className="flex w-full justify-between">
            <h2 className="text-txtGray text-lg">Total</h2>
            <div className="font-bold text-txtBlack text-lg">
              $ {currentOrder.totalPrice?.toFixed(2)}
            </div>
          </div>

          <div className="flex flex-row justify-end gap-4 mt-10">
            <button
              className="[width:200px] [height:48px] [border-radius:1rem] border border-black  "
              onClick={toggle}
            >
              <span className="text-txtBlack">Cancel</span>
            </button>
            <Button
              title="Save"
              className="mt-10 [width:200px] [min-height:48px] [margin:0px] [height:48px]"
              onClick={updateOrder}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditOrderModal;
